import request from '@/utils/request'

const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST

export function getIndustryListApi(params) {
  return request({
    url: jsApiHost + '/god/partner/sublist/get',
    method: 'get',
    params
  })
}
